export const activatedOption = [
    { value: "true", label: "true" },
    { value: "false", label: "false" },
  ];
  